module.exports = __webpack_public_path__ + "./Jenny_first_d79288ce6944987ee8b94c7b01bd5b2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jenny_first.jpg
// module id = 560
// module chunks = 0